import Emitter from "@homer.core/emitter";
import taskFetch from "@homer.task/fetch";
import isInstanceof from "@homer.utility/validator.isinstanceof";
import isString from "@homer.utility/validator.isstring";
import Request from "./request.js";

const html = document.documentElement;
const node = {
    ip: html.querySelector('head > meta[itemprop="ip"]'),
    country: html.querySelector('head > meta[itemprop="country"]'),
};
const bus = new Emitter();

export default class Client extends Emitter {
    constructor(base) {
        super();

        if (!isString(base)) {
            throw new TypeError("Argument `base` must be of type `string`");
        }

        Object.defineProperty(this, "base", {
            value: URL.resolve(base || "/"),
            enumerate: true,
        });
    }

    execute(request, endpoint, cache, credentials, prioritize = false, suppressEvents = false) {
        return Promise.resolve()
            .then(() => {
                if (endpoint && !isString(endpoint)) {
                    throw new TypeError("Argument `endpoint` must be of type `string`");
                }

                if (!isInstanceof(request, Request)) {
                    throw new TypeError("Argument `request` must be of type `Request` from `@homer.core/api`");
                }

                return Promise.all([request.header, request.data]).then(([header, data]) => {
                    request.header = header;
                    request.data = data;

                    return request;
                });
            })
            .then(async (request) => {
                // keep in mind: in case of a paged category page the endpoint does also include a querystring parameter and not only a pathname
                let url = this.base.href;

                if (!url.endsWith("/")) {
                    url += "/";
                }

                if (endpoint.startsWith("/")) {
                    endpoint = endpoint.substring(1);
                }

                url += endpoint;

                if (!suppressEvents) {
                    await bus.emit("request", { url, request, cache, credentials, prioritize });
                }

                const task = taskFetch.execute(url, request, cache, credentials, prioritize);

                request.once("abort", async (event, reason) => {
                    task.signal("abort", { reason });

                    if (!suppressEvents) {
                        await bus.emit("abort", { url, request, cache, credentials, prioritize, reason });
                    }
                });

                return task.then(async (response) => {
                    const { "x-source-ip": ip, "x-source-country": country, "x-origin": origin } = response?.headers || {};

                    if ((origin || "").indexOf("homer") !== 0) {
                        throw response;
                    }

                    if (ip) {
                        node.ip.setAttribute("content", ip);
                    }

                    if (country) {
                        node.country.setAttribute("content", country);
                    }

                    if (!suppressEvents) {
                        await bus.emit("response", { url, request, cache, credentials, prioritize, response });
                    }

                    return response;
                });
            });
    }

    static get bus() {
        return bus;
    }
}
